import LoadingButton from '@mui/lab/LoadingButton';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import useAlert from '../../component/Alert/useAlert';
import { ContextSelect } from '../../component/ContextSelect';
import { CountrySelector } from '../../component/CountrySelector';
import { CustomersTable } from '../../component/CustomerTable';
import { CategorySelect } from '../../component/Discount/CategorySelect';
import { DiscountConditionTable } from '../../component/Discount/DiscountConditionTable';
import DateInput from '../../component/input/DateInput';
import { NumberInput } from '../../component/input/NumberInput';
import { TextInput } from '../../component/input/TextInput';
import { PatientTypeSelect } from '../../component/PatientTypeSelect';
import { SubmitButton } from '../../component/SubmitButton';
import { customerRole } from '../../enum/customerRole';
import Title from '../../component/Title';
import { Box, Button, CardActions, CardContent } from '@mui/material';
import DiscountConditionApiService from '../../services/discountCondition.api.service';


const DiscountCondition = () => {
    const {showSuccessAlert, showErrorAlert} = useAlert();
    const [state, setState] = useState({
        context: null,
        customer: null,
        loading: false,
        createMode: false,
    });
    const [condition, setCondition] = useState({
        name: null,
        category: null,
        expires: null,
        amount: null,
        country: null,
        patient_type: null,
    });
    const defaultConditionState = {
        name: null,
        category: null,
        expires: null,
        amount: null,
        country: null,
        patient_type: null,
    };

    const changeState = (partialState) => setState(currentState => ({...currentState, ...partialState}));
    const changeConditionState = (partialState) => setCondition(currentState => ({...currentState, ...partialState}));
    const handleSubmit = () => {
        changeState({createMode: false});
        changeState({loading: true});
        DiscountConditionApiService
            .create({customer: state.customer.id, ...condition})
            .then(() => {
                showSuccessAlert('Discount condition successfully created');
                changeConditionState({...defaultConditionState});
                changeState({customer: {...state.customer}});
            })
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => changeState({loading: false}))
    };

    return (
        <Paper sx={{p: 4, display: 'flex', flexDirection: 'column', alignItems: 'left'}}>
            <Box
                component="form"
                noValidate={false}
                sx={{width: '100%'}}
            >
                <Title>1. Select the Business Context</Title>
                <ContextSelect onContextChange={context => changeState({context, customer: null})}/>
                <Title>2. Select customer with "Discount" role</Title>
                <CustomersTable
                    context={state.context}
                    role={customerRole.discounter}
                    onCustomerSelect={customer => changeState({customer})}
                />
                <Title>3. Discount conditions</Title>

                <DiscountConditionTable customer={state.customer} />

                <Grid container>
                    <Grid item lg={3} md={3} sm={3}/>
                    <Grid item lg={6} md={6} sm={6}>
                        {!state.createMode && <SubmitButton
                            text="Add discount condition"
                            handleSubmit={() => changeState({createMode: true})}
                        />}
                        {state.createMode && <Card sx={{minWidth: 275, backgroundColor: '#f4f4f4'}}>
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Create discount condition
                                </Typography>
                                <CountrySelector
                                    label="Country"
                                    onChange={country => changeConditionState({country: country.code})}
                                />
                                <TextInput
                                    label="Name"
                                    onChange={name => changeConditionState({name})}
                                />
                                <CategorySelect
                                    label="Product category"
                                    onChange={category => changeConditionState({category})}
                                />
                                <PatientTypeSelect
                                    label="Patient type"
                                    onChange={patient_type => changeConditionState({patient_type})}
                                />
                                <NumberInput
                                    label="Discount percentage, %"
                                    onChange={amount => changeConditionState({amount})}
                                />
                                <DateInput
                                    label="Expiring date"
                                    value={condition.expires}
                                    onChange={expires => changeConditionState({expires})}
                                />
                            </CardContent>
                            <CardActions sx={{justifyContent: 'space-between'}}>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    color="error"
                                    onClick={() => changeState({createMode: false})}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={handleSubmit}
                                    disabled={
                                        state.loading
                                        || !condition.name
                                        || !condition.amount
                                        || !condition.expires
                                        || !condition.country
                                        || !condition.category
                                        || !condition.patient_type
                                    }
                                >
                                    Submit
                                </Button>
                            </CardActions>
                        </Card>}
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};

export default DiscountCondition;
